/** Canonical super-admin role slugs (must match backend `SUPER_ADMIN_ROLE_SLUGS`). */
export const SUPER_ADMIN_ROLE_SLUGS = ['super-admin', 'super_admin'] as const;

export function isSuperAdminRoleSlug(slug: string | null | undefined): boolean {
  if (!slug) return false;
  return (SUPER_ADMIN_ROLE_SLUGS as readonly string[]).includes(slug);
}
